import React, { useEffect, useState } from 'react';
import { GrilleCard } from './GrilleCard';

const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const GrillesList = (parentProps) => {
    const [apprentis, setApprentis] = useState();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);

    useEffect(() => {
        const sg = parentProps.grilles.sort((a, b) => (a.apprenti > b.apprenti) ? 1 : ((b.apprenti > a.apprenti) ? -1 : 0));
        const groups = groupBy(sg, 'apprenti');
        setApprentis(groups);
    }, [parentProps.grilles]);

    if (apprentis) {
        return (<div className="grid">
            {Object.keys(apprentis).map((key, idxApp) => {
                return (
                    <React.Fragment key={`app${idxApp}`}>
                        <GrilleCard modules={apprentis[key]} handleGrilleSelection={parentProps.handleGrilleSelection} />
                    </React.Fragment>
                );
            })
            }</div>);
    }
    return <></>;
}